import { z } from 'zod';

export const TestimonialCreateSchema = z.object({
	name: z.string().min(1, 'Nome é obrigatório').max(120, 'Nome deve ter no máximo 120 caracteres'),
	occupation: z
		.string()
		.min(1, 'Cargo é obrigatório')
		.max(120, 'Cargo deve ter no máximo 120 caracteres'),
	testimonial: z
		.string()
		.max(480, 'Depoimento deve ter no máximo 480 caracteres')
		.optional(),
	status: z.string().min(1, 'Status é obrigatório'),
});

export const TestimonialUpdateSchema = z.object({
	name: z
		.string()
		.max(120, 'Nome deve ter no máximo 120 caracteres')
		.optional(),
	occupation: z
		.string()
		.max(120, 'Cargo deve ter no máximo 120 caracteres')
		.optional(),
	testimonial: z
		.string()
		.max(480, 'Depoimento deve ter no máximo 480 caracteres')
		.optional(),
	status: z.string().optional(),
});

export const AddLandingPlanSchema = z.object({
	planId: z.string().min(1, 'Plano é obrigatório'),
});

export const TESTIMONIAL_FIELD_LABELS: Record<string, string> = {
	name: 'Nome',
	occupation: 'Cargo',
	testimonial: 'Depoimento',
	status: 'Status',
};
